<script setup lang="ts">
const {
  icon,
  iconColor = 'white',
  disabled = false,
  size = '36px',
  iconSize = '24px',
} = defineProps<{
  icon?: string;
  iconColor?: string;
  iconSize?: string;
  disabled?: boolean;
  size?: string;
}>();

const emits = defineEmits(['click']);
const slots = useSlots();

const hasSlot = computed(() => !!slots.default);

const handleClick = () => {
  if (!disabled) {
    emits('click');
  }
};
</script>
<template>
  <div
    class="glass-button align-center justify-center"
    :class="{
      'glass-button--disabled': disabled,
    }"
    :style="{
      height: size,
      width: size,
    }"
    @click="handleClick()"
  >
    <slot data-testid="icon" />
    <template v-if="!hasSlot">
      <v-icon :icon="icon" :color="iconColor" :size="iconSize" class="glass-button__icon" data-testid="icon" />
    </template>
  </div>
</template>
<style lang="scss" scoped>
.glass-button {
  @include glass-layer-light;
  @include glass-layer-outline;
  display: flex;
  border-radius: 50%;
  cursor: pointer;

  &__icon {
    color: $text-color-primary;
  }
}

.glass-button.glass-button--disabled {
  cursor: not-allowed;
}
</style>
